import { InputCredentialController } from "../../controllers";

import { InputEnum } from "./InputEnum";

/**
 * Select credential.
 * @example
 * ```html
 * <salaxy-input-credential ng-model="credential" type="select"  name="Credential"  label="Credential"></salaxy-input-credential>
 * <salaxy-input-credential ng-model="credential" type="radio"  name="Credential" label="Credential" ></salaxy-input-credential>
 * <salaxy-input-credential ng-model="credential" type="typeahead"  name="Credential" label="Credential"></salaxy-input-credential>
 * ```
 */
export class InputCredential extends InputEnum {

    constructor() {
      super();
      /** Uses the InputEnumController */
      this.controller = InputCredentialController as any;
    }
}
